import React from 'react';
import useBottomSheetStore from '../store/useBottomSheetStore';
import '../styles/BottomSheet.css';

const BottomSheet = () => {
  const { isOpen, title, content, closeSheet } = useBottomSheetStore();

  return (
    <div className={`bottom-sheet ${isOpen ? "open" : ""}`} onClick={closeSheet}>
      <div className="bottom-sheet-content" onClick={(e) => e.stopPropagation()}>
        <div className="bottom-sheet-header">
          {title && <h2>{title}</h2>}
          <button className="bottom-sheet-close-button" onClick={closeSheet}>
            &times;
          </button>
        </div>
        <div className="bottom-sheet-body">{content}</div>
      </div>
    </div>
  );
};

export default BottomSheet;
